<template>
  <div>
    <answer-render ref="answer" :config="config" :cvtLang="cvtLang">
      <div class="multifillblank-box" slot="body">
        <div v-for="(item, index) in optionList" :key="item.id">
          <div class="title" v-html="item.displayTitle"></div>
          <div v-if="item.imgUrl" class="medio-main">
            <ipsos-av v-if="isAv(item.imgUrl)" :src="item.imgUrl"></ipsos-av>
            <ipsos-image v-else :imgUrl="item.imgUrl" :preview="item.id"></ipsos-image>
          </div>
          <FormItem :prop="`optionList.${index}.value`" :rules="rules">
            <div class="input-box">
              <Input
                class="textarea wyb"
                v-model="item.value"
                :placeholder="config.displayPlaceholder"
                type="textarea"
                :rows="config.answerConfig.inputSize"
                :maxlength="1000"
                @input="inputChange()"
              />
            </div>
          </FormItem>
        </div>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
import { mapState } from 'vuex'
export default {
  name: 'MultiFillBlankBoxAnswer',
  props: ['config'],
  data () {
    return {
      rules: [
        {
          validator: (rule, value, callback) => {
            const valIndex = Number(rule.field.split('.')[1])
            const errors = answerValidate.validate.bind(this.config)(this, true, valIndex).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      langMap: ({Question}) => Question.langMap,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
    }),
    optionList () {
      return this.config.optionList.filter(item => item.visibility)
    },
  },
  methods: {
    isAv (url) {
      return url && url.includes('.mp4')
    },
    inputChange() {
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
    },

    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    }
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
.multifillblank-box {
  margin-top: 15px;
  .title {
    font-size: 28px;
    margin-bottom: 10px;
  }
  .medio-main {
    margin-bottom: 20px;
    img {
      max-width: 100%;
    }
    .av-wrap {
      width: 100% !important;
    }
    >>> .video-js {
      width: 100% !important;
      height: 250px !important;
    }
  }
}
.answer-pc {
  .multifillblank-box {
    margin-top: 0px;
    .title {
      font-size: 14px;
      margin-bottom: 5px;
    }
    .medio-main {
      margin-bottom: 10px;
      img {
        max-width: 100%;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/editor/MultiFillBlankBox/MultiFillBlankBoxAnswer.vue